// extracted by mini-css-extract-plugin
module.exports = {"contentArea":"Selector_contentArea__1HogK","title":"Selector_title__aSyKo","option":"Selector_option__lBVF2","input":"Selector_input__3kg1X"};